import React, { useContext } from "react";
import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/cmap2010/home";

import bottom_nav_schedule_true from "bodycodi/cmap/app/svg/bottom_nav_schedule_true.svg";
import bottom_nav_schedule_false from "bodycodi/cmap/app/svg/bottom_nav_schedule_false.svg";
import bottom_nav_user_true from "bodycodi/cmap/app/svg/bottom_nav_user_true.svg";
import bottom_nav_user_false from "bodycodi/cmap/app/svg/bottom_nav_user_false.svg";
import bottom_nav_community_true from "bodycodi/cmap/app/svg/bottom_nav_community_true.svg";
import bottom_nav_community_false from "bodycodi/cmap/app/svg/bottom_nav_community_false.svg";
import bottom_nav_store_true from "bodycodi/cmap/app/svg/bottom_nav_store_true.svg";
import bottom_nav_store_false from "bodycodi/cmap/app/svg/bottom_nav_store_false.svg";
import bottom_nav_plus_true from "bodycodi/cmap/app/svg/bottom_nav_plus_true.svg";
import bottom_nav_plus_false from "bodycodi/cmap/app/svg/bottom_nav_plus_false.svg";

const REACT_APP_API = process.env.REACT_APP_API;

const Footer = () => {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);
  const isGoto = REACT_APP_API?.includes("goto");

  const clickFooter = (i: number) => () => {
    dispatch({ type: "CLICK_FOOTER", state: i });
  };

  return (
    <div className="footer">
      <div className="btn" onClick={clickFooter(0)}>
        <img src={state.bodyState === 0 ? bottom_nav_schedule_true : bottom_nav_schedule_false} />
        <div className={"text" + (state.bodyState === 0 ? " active" : "")}>내 스케줄</div>
      </div>
      <div className="btn" onClick={clickFooter(1)}>
        <img src={state.bodyState === 1 ? bottom_nav_user_true : bottom_nav_user_false} />
        <div className={"text" + (state.bodyState === 1 ? " active" : "")}>회원관리</div>
      </div>
      <div className="btn" onClick={clickFooter(2)}>
        <img src={state.bodyState === 2 ? bottom_nav_community_true : bottom_nav_community_false} />
        <div className={"text" + (state.bodyState === 2 ? " active" : "")}>커뮤니티</div>
      </div>
      <div className="btn" onClick={clickFooter(3)}>
        <img src={state.bodyState === 3 ? bottom_nav_store_true : bottom_nav_store_false} />
        <div className={"text" + (state.bodyState === 3 ? " active" : "")}>스토어</div>
      </div>
      {!isGoto && (
        <div className="btn" onClick={clickFooter(4)}>
          <img src={state.bodyState === 4 ? bottom_nav_plus_true : bottom_nav_plus_false} />
          <div className={"text" + (state.bodyState === 4 ? " active" : "")}>플러스</div>
        </div>
      )}
    </div>
  );
};

export default Footer;
